import React from 'react';

const EShop = (props) => (
    <div className="row justify-content-center">
        <div className="col-md-10">
            <h2 className="display-4 text-center">„Е-МАГАЗИН“</h2>
            <h3 className="display-5  text-center">ЗА ДУХОВНИ ПОТРЕБИ</h3>
            <p className="text-justify">Нашият online магазин за духовни потреби пастри гореща памет за съкровищата на условното „Царство Паисиада“. Покупко-продажбите в него имат единствено символична стойност – цената е познанието по теми от паисиезнанието.
            </p>
            <blockquote className="text-center">НИЕ НЕ ПРОДАВАМЕ, А ДАРЯВАМЕ: ДАРЯВАМЕ ЗНАНИЕ, КОЕТО ОТКЛЮЧВА ДУХОВНОСТ!
            </blockquote>
            <p className="text-justify">Потребителю на глобалните технологии, предлагаме ти да провериш своето познание по българознание и българолюбие. Викторината е разработена така, че всяко следващо ниво се отваря единствено, ако отговорът на въпроса от преходното ниво е верен. А всеки верен отговор носи духовен подарък, който разбужда спомените за „Паисиада“. Ако вече си любопитен да узнаеш точната „цена“ на покупко-продажбите в „е-магазина“ ни за духовни потреби, то тогава ни последвай и по-нататък. Но първо–разузнай паисиеведските сайтове:
            </p>
            <div className="text-center">
                <a className="btn btn-danger" href="http://paissiada.com" target="_blank">paissiada.com</a>&nbsp;&nbsp;
                <a className="btn btn-danger" href="http://nauho.paissiada.com" target="_blank">nauho.paissiada.com</a>&nbsp;&nbsp;
                <a className="btn btn-danger" href="http://geographyofletters.org" target="_blank">geographyofletters.org</a>&nbsp;&nbsp;
            </div>
            <p className="text-justify">Тези сайтове ще ти помогнат да преминеш успешно нашата викторина.</p>
            <p className="text-justify"> А сега – НА ДОБЪР ЧАС в пътешествието ти из дебрите на българската възрожденска култура и ръкописната „Паисиада“.</p>
            <div className="text-center">
                <a className="btn btn-danger" href="https://goo.gl/forms/epSTpki9irbriVFk1" target="_blank">Към викторината:</a>
            </div>
        </div>
    </div>
);

export default EShop


// WEBPACK FOOTER //
// ./src/views/Home/e-shop.block.jsx